export const classNames = (...classes: any) => {
    return classes.join(" ");
}